import { ButtonBase } from "@mui/material";
import { useIntl } from "react-intl";

import { CaretRightIcon } from "@/components/Icons/rtlReadyIcons";
import type { MappedServiceData } from "@/features/flights/components/flight-purchase/AdditionalServicesSelection/types";
import type { AdditionalServiceData } from "@/features/flights/types/types";

interface Props {
  service: MappedServiceData;
  selectedServices: AdditionalServiceData[];
  onClick: (service: MappedServiceData) => void;
}

export const SelectMealButton = ({
  service,
  selectedServices,
  onClick,
}: Props) => {
  const intl = useIntl();

  return (
    <ButtonBase
      sx={{
        padding: "calc(var(--spacing) * 3)",
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "#f0f0f0",
        borderRadius: "var(--radius-2xl)",
        backgroundColor: "var(--color-core-cadet-100)",
      }}
      onClick={() => onClick(service)}
    >
      <div className="flex flex-col items-start gap-0.5">
        <div className="text-sm font-medium text-black">
          {intl.formatMessage({
            defaultMessage: "Select meal",
            description: "Button label to select a meal option for a traveller",
          })}
        </div>
        {(() => {
          const numberOfSelectedServices = selectedServices.reduce(
            (acc, selectedService) => {
              if (
                selectedService.service.bookingCode ===
                service.service.bookingCode
              ) {
                return acc + 1;
              }
              return acc;
            },
            0,
          );

          if (numberOfSelectedServices > 0) {
            return (
              <div className="text-sm font-medium text-core-accent-600">
                {intl.formatMessage(
                  {
                    defaultMessage:
                      "{amount, plural, one {# Meal} other {# Meals}} selected",
                    description:
                      "Count of meal options selected for a traveller",
                  },
                  { amount: numberOfSelectedServices },
                )}
              </div>
            );
          } else {
            return (
              <div className="text-sm font-medium text-text-tertiary">
                {intl.formatMessage({
                  defaultMessage: "No meal selected",
                  description:
                    "Status label indicating no meal has been chosen for a traveller",
                })}
              </div>
            );
          }
        })()}
      </div>
      <CaretRightIcon color="var(--color-stone)" weight="bold" />
    </ButtonBase>
  );
};
